import { createTheme } from '@mantine/core';

export const theme = createTheme({
  primaryColor: 'brand',
  primaryShade: 9,
  colors: {
    brand: [
      '#f4f1ff',
      '#e5dbff',
      '#d0bfff',
      '#b197fc',
      '#9775fa',
      '#845ef7',
      '#7950f2',
      '#7048e8',
      '#6741d9',
      '#5f3dc4',
    ],
  },
  fontFamily: "'Google Sans Flex', sans-serif",
  headings: {
    fontFamily: "'Google Sans Flex', sans-serif",
  },
  defaultRadius: 'md',
  components: {
    Button: {
      defaultProps: {
        variant: 'filled',
      },
    },
    Badge: {
      defaultProps: {
        variant: 'filled',
        color: 'brand',
      },
      styles: {
        root: {
          textTransform: 'uppercase',
          letterSpacing: '0.08em',
          fontWeight: 800,
        },
        label: {
          color: 'inherit',
        },
      },
    },
  },
});
